import styled from "styled-components";
import bgDesktop from "../images/how_bg_desktop.png";
import bgMobile from "../images/how_bg_mobile.png";

const Wrapper = styled.div`
  background: linear-gradient(rgba(15, 44, 89, 0.85), rgba(15, 44, 89, 0.85)), url(${bgDesktop});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  padding: 100px 0;
  overflow: hidden;
  position: relative;

  @media (max-width: 768px) {
    background: linear-gradient(rgba(15, 44, 89, 0.9), rgba(15, 44, 89, 0.9)), url(${bgMobile});
    background-size: cover;
    background-position: center;
    background-attachment: scroll; /* Fixed bg can be buggy on mobile */
  }

  .container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    align-items: center;
    max-width: 1100px; /* Constrain width for better reading */

    @media (max-width: 1020px) {
      grid-template-columns: 1fr;
      padding: 0 40px;
      gap: 40px;
    }
    
    @media (max-width: 600px) {
      padding: 0 20px;
    }

    .left {
      h3 {
        color: var(--secondary-color); /* Gold */
        font-family: 'Playfair Display', serif;
        font-size: 2.5rem;
        margin-bottom: 50px;
        position: relative;
        padding-bottom: 20px;
        
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 80px;
          height: 3px;
          background-color: var(--secondary-color);
        }

        @media (max-width: 1020px) {
          text-align: center;
          &::after { left: 50%; transform: translateX(-50%); }
        }
      }

      .list-container {
        color: #f8f9f7;
        display: flex;
        flex-direction: column;
        gap: 35px;

        .item {
          display: flex;
          gap: 25px;
          align-items: flex-start;

          .number {
            flex-shrink: 0;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background-color: transparent;
            border: 2px solid var(--secondary-color);
            color: var(--secondary-color);
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            padding: 0;
            line-height: normal; /* Avoid baseline clipping */
            font-size: 1.4rem;
            font-weight: 700;
            font-family: 'Playfair Display', serif;
            transition: var(--transition);
          }
          
          &:hover .number {
            background-color: var(--secondary-color);
            color: var(--primary-color);
          }

          .content {
            padding-top: 5px;
            h4 {
              color: var(--white);
              font-size: 1.3rem;
              font-weight: 700;
              margin-bottom: 8px;
              font-family: 'Playfair Display', serif;
            }
            p {
              font-size: 1.05rem;
              color: rgba(255, 255, 255, 0.8);
              line-height: 1.6;
              font-family: 'Lato', sans-serif;
            }
          }
        }
      }
    }

    .right {
      height: auto;
      display: flex;
      justify-content: center;

      @media (max-width: 1020px) {
        /* Keep image visible on mobile but smaller if needed, or hide if it crowds */
        display: none; 
      }

      .image {
        width: 100%;
        max-width: 500px;
        height: auto;
        border-radius: var(--radius);
        /* If the image is a diagram with white bg, might need blending or transparency. 
           Assuming it's a vector/transparent png. If not, we might hide it or replace it. */
        filter: drop-shadow(0 10px 20px rgba(0,0,0,0.3));
      }
    }
  }
`;

export default Wrapper;
